import React from "react";
import { useForm, SubmitHandler } from "react-hook-form";
import "dayjs/locale/en";
import { CNYProps, FormInputs } from "../../../../../types/walletTypes";
import { formRegistry } from "../formRegistry";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { savedCNYData } from "../../../redux/formDataSlice";

const Sender = ({ handleNext, handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);

  const { ...defaultValues } = getSavedData || {};

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormInputs>({
    defaultValues,
  });

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  const currentStep = "sender";

  const CurrentStepComponent = formRegistry[currentStep]?.[
    getSavedData?.paymentMethod
  ] as any;

  if (!CurrentStepComponent) return null;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <CurrentStepComponent
        control={control}
        errors={errors}
        handleNext={handleNext}
        handlePrevious={handlePrevious}
      />
    </form>
  );
};

export default Sender;
